import {ElementRef, QueryList, HostBinding, Inject, Injector} from '@angular/core';
import {Component, OnInit, Input, ViewChildren} from '@angular/core';
import {WistiaVideoComponent} from '../wistia-video/wistia-video.component';
import {WorkspaceServiceService} from '../../services/workspace-service.service';
import {Utils} from '../../utils';
import {AppComponentBase} from '../../services/AppComponentBase';
import {showScannerTrialPopupModal} from '../scanner/modals/ScannerTrialPopup/show-ScannerTrialPopup-modal';


@Component({
    selector: 'tutorial-video-window',
    template: require('./tutorial-video-window.component.html'),
    styles: [require('./tutorial-video-window.component.css')]
})
export class TutorialVideoWindowComponent extends AppComponentBase implements OnInit {

    @ViewChildren(WistiaVideoComponent) videoElements?: QueryList<WistiaVideoComponent>;

    @HostBinding('class.bigWindow')
    bigWindow = false;

    @HostBinding('class.hidden')
    private get hidden() {
        return !this.open;
    }

    public set open(value: boolean) {
        if(value == this.open)
            return;

        if(this.activeVideoElement) {
            if(value == false) {


                console.log('tutorial video closed wistiaVideoid: ' + this.activeVideoElement.videoId);

                if(this.activeVideoElement.videoId) {
                    this.showScannerTrialPopup();
                }


                this.activeVideoElement.pause();
            }


            if(value == true && this.playOnOpen)
                this.activeVideoElement.play();
        }
        this._open = value;
        if(value == false) this.bigWindow = false;
    }

    public get open() {
        return this._open;
    }

    private _open = false;

    videos: string[] = [];

    openOnVideoSet = true;

    playOnOpen = true;

    playOnVideoChange = true;

    @Input()
    set activeVideo(value: string | null) {
        if(this.activeVideo != value) {
            if(this.activeVideoElement != null)
                this.activeVideoElement.pause();

            if(value != null && this.videos.indexOf(value) == -1) this.videos.push(value);

            this._activeVideo = value;

            if(this.playOnVideoChange) {
                Utils.waitFor(() => this.activeVideoElement != null, () => {
                    if(this.activeVideoElement) this.activeVideoElement.play();
                });
            }
        }

        if(value != null && this.openOnVideoSet)
            this.open = true;
    }

    get activeVideo(): string | null {
        return this._activeVideo;
    }

    get activeVideoElement() {
        if(this.videoElements == null)
            return null;
        return this.videoElements.find(v => v.videoId == this.activeVideo);
    }

    _activeVideo: string | null = null;

    constructor(
        protected workspaceService: WorkspaceServiceService,
        injector: Injector
    ) {
        super(injector);
        (window as any).tvw = this.workspaceService.data.tutorialVideoWindow = this;
    }

    ngOnInit() {

    }

    onVideoEnded(wistiaVideo: WistiaVideoComponent) {
        console.log('tutorial video ended wistiaVideoid: ' + wistiaVideo.videoId);

        if(wistiaVideo.videoId) {
            this.showScannerTrialPopup();
        }

        if(wistiaVideo.videoId) this.workspaceService.data.addWatchedVideo(wistiaVideo.videoId);
    }

    public scannerPopupDelay = 120000;
    public showScannerTrialPopup() {
        if(this.workspace.allowScannerTrial) {
            setTimeout(() => {

                if(this.workspace.mobileMode=="desktop")
                showScannerTrialPopupModal(this.modalService, this.workspace, this.workspace.mobileMode);

            }, this.scannerPopupDelay);

        }


    }

}
